module.exports = __webpack_public_path__ + "img/total_reply.f045a13b.svg";